/*=============================================== DemoCustomPaginator ===============================================*/

import { useState } from "react"
import type { ChangeEvent } from "react"
import { useSearchParams } from "react-router-dom"
import {
    Paginator,
    Card,
    Text,
    Grid,
    uuid,
    generateNumbers,
    scrollToTop,
} from "tsx-library-julseb"

import { WrapperPagination } from "components"

const DemoCustomPaginator = () => {
    const arr: string[] = generateNumbers(1, 201).map(n => `Hello ${n}`)
    const dataLimit: number = 20

    const totalPages: number = Math.ceil((arr?.length || 0) / dataLimit)

    const [searchParams, setSearchParams] = useSearchParams()
    const page = searchParams.get("page") || "1"

    const [currentPage, setCurrentPage] = useState<number>(parseInt(page))

    const handlePrev = () => {
        setSearchParams({ page: (currentPage - 1).toString() })
        setCurrentPage(currentPage - 1)
        scrollToTop()
    }

    const handleNext = () => {
        setSearchParams({ page: (currentPage + 1).toString() })
        setCurrentPage(currentPage + 1)
        scrollToTop()
    }

    const handlePage = (e: ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value)

        const selectedPage =
            value > totalPages
                ? totalPages
                : value <= 1 || !e.target.value
                ? 1
                : value

        setSearchParams({ page: selectedPage.toString() })
        setCurrentPage(selectedPage)
        scrollToTop()
    }

    const getPaginatedData = () => {
        const startIndex = currentPage * dataLimit - dataLimit
        const endIndex = startIndex + dataLimit
        return arr?.slice(startIndex, endIndex)
    }

    return (
        <WrapperPagination title="Demo Paginator query">
            {getPaginatedData() && (
                <Grid col={4} gap="s">
                    {getPaginatedData().map(text => (
                        <Card border={{ width: 1 }} key={uuid()}>
                            <Text>{text}</Text>
                        </Card>
                    ))}
                </Grid>
            )}

            {totalPages > 1 && (
                <Paginator
                    totalPages={totalPages}
                    page={currentPage}
                    handlePrevPage={handlePrev}
                    handleNextPage={handleNext}
                    handleInput={handlePage}
                />
            )}
        </WrapperPagination>
    )
}

export default DemoCustomPaginator
